/**
 * Return the JSON object from the script tag with the given id.
 *
 * For security reasons, the JSON is made available in a CDATA section.
 *
 * @example getScriptJson('current-user-json')
 * @returns object
 */

export default function getScriptJson(id: string) {
	const script = document.getElementById(id)

	if (!script?.textContent) {
		return {}
	}

	// cSpell:words domjs
	// This would be a nicer implementation, but domjs doesn't support it nicely:
	/*
	const scriptNode = new DOMParser().parseFromString(script.outerHTML, 'text/xml').firstChild

	if (!scriptNode?.childNodes[1]?.textContent) {
		return {}
	}
	const scriptContent = scriptNode.childNodes[1].textContent.replace(/\/\/$/, '').trim()
	*/
	// The downside is that the implementation below doesn't work if the JSON content contains
	// the ']]>' string. On the other side, none of our JSON content is supposed to contain
	// such a string, so we should be fine.

	const scriptContent = script.textContent.replace('//]]>', '').replace('//<![CDATA[', '').trim()

	return JSON.parse(scriptContent)
}
